import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/joy';

function BillProgress({ actions }) {
  const progressSteps = [
    { title: 'Introduced', key: 'Introduced' },
    { title: 'Committee',  key: 'Committee'  },
    { title: 'House Vote', key: 'House'      },
    { title: 'Senate Vote',key: 'Senate'     },
    { title: 'Signed',     key: 'BecameLaw'  },
  ];

  const getStepStatus = (stepKey) => {
    if (!actions || actions.length === 0) return false;
    const actionText = actions
      .map(a => (typeof a === 'string' ? a : a?.text) || '')
      .join(' ')
      .toLowerCase();
    if (stepKey === 'Introduced') return true;
    if (stepKey === 'Committee')  return actionText.includes('committee') || actionText.includes('referred');
    if (stepKey === 'House')      return actionText.includes('passed house') || actionText.includes('house passed');
    if (stepKey === 'Senate')     return actionText.includes('passed senate') || actionText.includes('senate passed');
    if (stepKey === 'BecameLaw')  return actionText.includes('became law') || actionText.includes('signed into law');
    return false;
  };

  const lastCompletedIndex = progressSteps.reduce(
    (acc, step, i) => (getStepStatus(step.key) ? i : acc),
    -1
  );

  const getStepState = (stepKey, index) => {
    if (getStepStatus(stepKey)) return 'completed';
    if (index === lastCompletedIndex + 1) return 'current';
    return 'future';
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '11px',
          fontWeight: 700,
          color: '#fdf0d5',
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          mb: '20px',
        }}
      >
        Bill progress
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'flex-start', px: '4px' }}>
        {progressSteps.map((step, index) => {
          const state = getStepState(step.key, index);
          const isLast = index === progressSteps.length - 1;

          return (
            <React.Fragment key={index}>
              <Stack alignItems="center" spacing="10px" sx={{ flexShrink: 0, width: '64px' }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ...(state === 'completed' && { backgroundColor: '#0075b2' }),
                    ...(state === 'current'   && { border: '2px solid #fdf0d5' }),
                    ...(state === 'future'    && { border: '2px solid rgba(255,255,255,0.2)' }),
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '18px',
                      fontWeight: 500,
                      lineHeight: 1,
                      color:
                        state === 'completed' ? 'white'
                        : state === 'current'  ? '#fdf0d5'
                        : 'rgba(255,255,255,0.3)',
                    }}
                  >
                    {index + 1}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: '13px',
                    fontWeight: state === 'future' ? 400 : 600,
                    lineHeight: 1.3,
                    color: state === 'future' ? 'rgba(255,255,255,0.4)' : 'white',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {step.title}
                </Typography>
              </Stack>

              {!isLast && (
                <Box
                  sx={{
                    flex: 1,
                    height: '1px',
                    mt: '24px',
                    alignSelf: 'flex-start',
                    backgroundColor: index < lastCompletedIndex ? '#0075b2' : 'rgba(255,255,255,0.15)',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
}

BillProgress.propTypes = {
  actions: PropTypes.array,
};

export default BillProgress;
